export default "__VITE_ASSET__DoXfQJ$Z__"